import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function About() {
  return <section id="sobre-mi" className="py-14 md:py-20 bg-brand-cream overflow-hidden" data-id="element-36">
      <div className="max-w-6xl mx-auto px-6" data-id="element-37">
        <div className="flex flex-col md:flex-row items-center gap-16 md:gap-24" data-id="element-38">
          <div className="w-full md:w-1/2" data-id="element-39">
            <FadeIn direction="none" data-id="element-40">
              <div className="relative w-full max-w-md mx-auto aspect-[3/4] rounded-[2rem] overflow-hidden" data-id="element-41">
                <img src="https://cdn.magicpatterns.com/uploads/qQGKccoWchp21e5EsBiRnn/image.png" alt="Helen Gerberg" className="w-full h-full object-cover object-center" data-id="element-42" />
              </div>
            </FadeIn>
          </div>

          <div className="w-full md:w-1/2 flex flex-col items-start text-left" data-id="element-43">
            <FadeIn data-id="element-44">
              <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-brand-ink mb-8" data-id="element-45">
                Soy Helen Gerberg
              </h2>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-46">
              <div className="space-y-6 font-sans text-brand-ink/80 text-lg leading-relaxed mb-10" data-id="element-47">
                <p data-id="element-48">Mentora en autoconocimiento y desarrollo espiritual.</p>
                <p data-id="element-49">
                  Durante 10 años fui oficial naval. Aprendí disciplina,
                  estructura y compromiso, pero también descubrí que muchas
                  veces podemos pasar años viviendo desde lo que se espera de
                  nosotros sin detenernos a escuchar quiénes somos realmente.
                </p>
                <p data-id="element-50">
                  Las pérdidas, las relaciones, la migración, el emprendimiento
                  y la maternidad profundizaron mi camino de autoconocimiento y
                  me llevaron a buscar respuestas más allá de la superficie.
                </p>
                <p data-id="element-51">
                  Hoy integro el Diseño Humano, la Gestión Emocional y el
                  Desarrollo Espiritual para ayudarte a comprender quién eres,
                  mirar tus patrones con amor y construir una vida más alineada
                  con tu verdadera naturaleza.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-52">
              <div className="pl-6 border-l-2 border-brand-eucalyptus py-2" data-id="element-53">
                <p className="font-serif text-2xl text-brand-ink italic" data-id="element-54">
                  "Mi trabajo no es decirte quién debes ser. Es ayudarte a
                  recordar quién eres."
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}